export default __webpack_public_path__ + "static/media/lea-profile.1538891d.png";